import { GetStaticPaths, GetStaticProps } from 'next'
import {
    getAllPodcast,
    getAllPodcastBySlug
} from "../../lib/api"
import Layout from "../../components/layout";
import Link from "../../components/Link";
import {mwImage} from "../../lib/common";
import PostBody from "../../components/post-body";
import CallToActionSmall from "../../components/v2/call-to-action-sm";
import {LinkedInIcon, TwitterIcon} from "../../components/v2/icons";
import dayjs from "dayjs";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/blog.module.scss';

const parentPage = "podcast"

export default function PodcastSlug({pageData}) {
    const post = pageData?.allPodcast?.edges[0]?.node
    const featuredImage = mwImage(post?.featuredImage?.node.sourceUrl);

    let postContent = post?.content.replaceAll(
        "https://middleware.io/backend/wp-content",
        "https://middleware.io/wp-content"
    );

    const slugShare = "https://middleware.io/podcast/" + post?.slug + "/";
    const twitterShare =
        "https://x.com/share?url=" +
        encodeURIComponent(slugShare) +
        "&text=" +
        encodeURIComponent(post?.title) +
        "&via=Middleware_Labs";
    const linkedInShare =
        "https://www.linkedin.com/shareArticle?mini=true&url=" +
        encodeURIComponent(slugShare);
    return (
        <>
            <Layout isHomePage={false} pageTitle={post?.title}
                    ogImage={post?.featuredImage?.node?.sourceUrl}
                    uri={post?.uri}
                    metaTitle={post?.seo?.title}
                    metaDesc={post?.seo?.metaDesc}
                    metaRobotsNoindex={post?.seo?.metaRobotsNoindex}
                    metaRobotsNofollow={post?.seo?.metaRobotsNofollow}>
                <div className={"middle-wrapper site-page product-update-single-page"}>
                    <section className={"single-blog-v2"}>
                        <div className={"container"}>
                            <div className={"inner-blog"}>
                                <div className={"d-flex hero-section inner-podcast"}>
                                    <div className={"left-block"}>
                                        <Link href={"/podcast/"} className={"back-to-blog"}>
                                            Back to Podcast
                                        </Link>
                                        <div className={"category-episode"}>
                                            <div className={"category knowledge"}>{post?.podcast?.episode}</div>
                                            <div className={"category gray"}>{post?.seo?.readingTime} Mins</div>
                                            <div className={"category gray"}>{dayjs(post?.date).format("D MMM YYYY")}</div>
                                        </div>
                                        <h1>{post?.title}</h1>

                                    </div>
                                    <div className={"right-block"}>
                                        <div className="blog-single-hero-image">
                                            <img
                                                src={featuredImage}
                                                alt={post?.title}
                                                width="500"
                                                height="255"
                                                loading="lazy"
                                            />
                                            {post?.podcast?.mediaUrl != undefined && <Link href={post?.podcast?.mediaUrl} target={"_blank"} skipLocaleHandling={true}><span className={"play-button"}>
                                                <img src={"/images/play-now-button.svg"} alt={"Play Button"} width={100} height={100}/>
                                            </span></Link>}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                            <div className={"container"}>
                                <div className={"inner-blog"}>
                                    <div className={"d-flex blog-main-content"}>
                                        <div className={"left-block"}>
                                            <div className={"sticky-share podcast-share"}>
                                                <div className={"left-guest"}>
                                                    <h4>Guest</h4>
                                                    <Link href={post?.podcast?.guest?.profileUrl !== null ? post?.podcast?.guest?.profileUrl : "/"} target={"_blank"} skipLocaleHandling={true}>
                                                        <div className={"flex-guest"}>
                                                            <img src={post?.podcast?.guest?.profileImage == null ? "/images/podcast/default.svg" : post?.podcast?.guest?.profileImage?.sourceUrl} alt={"Guest"} width={100} height={100} />
                                                            <div>
                                                                <p>{post?.podcast?.guest?.name}</p>
                                                                <p className={"primary"}>{post?.podcast?.guest?.designation}</p>
                                                            </div>
                                                        </div>
                                                    </Link>

                                                </div>

                                                <div className={"left-guest"}>
                                                    <h4>Host</h4>
                                                    <Link href={post?.podcast?.hostBy?.profileUrl !== null ? post?.podcast?.hostBy?.profileUrl : "/"} target={"_blank"} skipLocaleHandling={true}>
                                                        <div className={"flex-guest"}>
                                                            <img src={post?.podcast?.hostBy?.profileImage == null ? "/images/podcast/default.svg" : post?.podcast?.hostBy?.profileImage?.sourceUrl} alt={"Guest"} width={100} height={100} />
                                                            <div>
                                                                <p>{post?.podcast?.hostBy?.name}</p>
                                                                <p className={"primary"}>{post?.podcast?.hostBy?.designation}</p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>

                                                <div className={"share-list"}>
                                                    <p>Share Now:</p>
                                                    <div className={"share-icon"}>
                                                        <Link href={twitterShare} target={"_blank"} skipLocaleHandling={true}>
                                                            <TwitterIcon />
                                                        </Link>
                                                        <Link href={linkedInShare} target={"_blank"} skipLocaleHandling={true}>
                                                            <LinkedInIcon />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"main-content"}>
                                            <PostBody content={postContent?.replace(
  /<iframe([^>]*)>(.*?)<\/iframe>/gi,
  "<iframe$1></iframe>"
)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </section>

                    <CallToActionSmall />
                </div>
            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const { params } = ctx;
    const data = await getAllPodcastBySlug(params?.slug as string, parentPage)
    const post = data?.allPodcast?.edges[0]?.node

    const translations = await serverSideTranslations(
      ctx?.locale ?? "en",
      ["common", "header", "footer"],
      nextI18NextConfig,
    );
    return {
        props: {
            ...translations,
            pageData: data,
            pageTitle: post?.seo?.title,
            description:post?.seo?.metaDesc,
            ogImage:post?.featuredImage?.node.sourceUrl || null,
            uri:post?.uri,
            metaTitle:post?.seo?.title,
            metaDesc:post?.seo?.metaDesc,
            metaRobotsNoindex:post?.seo?.metaRobotsNoindex,
            metaRobotsNofollow:post?.seo?.metaRobotsNofollow,
        },
    }
}
export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
    const allPodcast = await getAllPodcast()
    const paths = allPodcast.edges.flatMap(({ node }) => {
        return (locales || nextI18NextConfig.i18n.locales).map((locale) => ({
            params: { slug: node?.slug },
            locale,
        }));
    }) || [];
    return {
        paths: paths,
        fallback: 'blocking',
    };
}
